import _bundle from '../core--bundles';
import { _g } from '../core--base';

const { _library } = _g;
const { _utils } = _library;

export default function() {
    const $el = $('#event-test-poll');
    _utils
        .poll(
            function() {
                return $el.attr('data-element-created') === 'yes';
            },
            4000,
            150
        )
        .then(function() {
            $el.prepend($(`<li>Poll Done!</li>`));
        })
        .catch(function() {});
}
